import { ScaffoldDropZone } from "../../scaffold";
import {
  ARST_ADD_OPERATION_TO_GROUP,
  ARST_REMOVE_GROUPINGFACTOR,
  ARST_SET_FIRST_COLUMN,
  ARST_SET_FIRST_ROW,
  ARST_TOGGLE_GROUP_LABEL_VISIBILITY,
  ArsTableCellActionConfig,
  ArsTableCellData,
  ArsTableCellType,
  ArsTableContextMenuActionDefinition,
  ArsTableSidebarItemKind,
  ArsTableState,
} from "./interface";

export const removeGroupingFactor: ArsTableContextMenuActionDefinition = {
  label: "Remove group",
  operation: ARST_REMOVE_GROUPINGFACTOR,
};
export const toggleGroupFactorLabel: ArsTableContextMenuActionDefinition = {
  label: "Toggle group label",
  operation: ARST_TOGGLE_GROUP_LABEL_VISIBILITY,
};

/**
 * Create action configuration for a given cell
 *
 * @param value - The value of the cell for which the action configuration is being generated
 * @param state - The current state of the ArsTable
 * @returns The action configuration for the given cell
 */
export const cellActionConfig: <T>(
  value: ArsTableCellData<T>,
  state: ArsTableState<T> | null,
) => ArsTableCellActionConfig = (value, state) => {
  if (!state)
    return {
      contextMenuActions: [],
      dropActions: [],
    };

  switch (value.cellType) {
    case ArsTableCellType.ColumnGroupCell:
    case ArsTableCellType.RowGroupCell:
      return {
        contextMenuActions: [toggleGroupFactorLabel, removeGroupingFactor],
        dropActions: [],
      };
    case ArsTableCellType.ColumnGroupLabel:
      return {
        contextMenuActions: [toggleGroupFactorLabel],
        dropActions: [
          {
            droppedDataKinds: [ArsTableSidebarItemKind.Operation],
            dropZones: [
              ScaffoldDropZone.CentreTopLeft,
              ScaffoldDropZone.CentreTopRight,
              ScaffoldDropZone.CentreBottomLeft,
              ScaffoldDropZone.CentreBottomRight,
              ScaffoldDropZone.BottomLeft,
              ScaffoldDropZone.BottomEdgeLeft,
              ScaffoldDropZone.BottomEdgeRight,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_ADD_OPERATION_TO_GROUP,
          },
        ],
      };
    case ArsTableCellType.RowGroupLabel:
      return {
        contextMenuActions: [toggleGroupFactorLabel],
        dropActions: [
          {
            droppedDataKinds: [ArsTableSidebarItemKind.Operation],
            dropZones: [
              ScaffoldDropZone.CentreTopLeft,
              ScaffoldDropZone.CentreTopRight,
              ScaffoldDropZone.CentreBottomLeft,
              ScaffoldDropZone.CentreBottomRight,
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_ADD_OPERATION_TO_GROUP,
          },
        ],
      };
    case ArsTableCellType.RowHeader:
      return {
        contextMenuActions: [],
        dropActions: [
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_SET_FIRST_COLUMN,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.BottomLeft,
              ScaffoldDropZone.BottomEdgeLeft,
              ScaffoldDropZone.BottomEdgeRight,
            ],
            operation: ARST_SET_FIRST_ROW,
          },
        ],
      };
    default:
      return {
        contextMenuActions: [],
        dropActions: [],
      };
  }
};
